import { render, staticRenderFns } from "./childSlot.vue?vue&type=template&id=611ddbfc&scoped=true&"
import script from "./childSlot.vue?vue&type=script&lang=js&"
export * from "./childSlot.vue?vue&type=script&lang=js&"
import style0 from "./childSlot.vue?vue&type=style&index=0&id=611ddbfc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611ddbfc",
  null
  
)

component.options.__file = "childSlot.vue"
export default component.exports